export default __webpack_public_path__ + "static/media/BaseballBat_4.3a0ea637.png";